import { Alert, AlertDescription } from "@babackapp/customer-ui/components/alert";
import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { TextDto } from "@babackapp/private-api-client";
import { pickLocalizedText } from "../utils/pick-localized-text";

type Props = {
  texts?: TextDto[] | null;
};

export function UserPortalCallout({ texts }: Props) {
  const { i18n } = useTranslation("return-widget-v3");

  if (!texts?.length) return null;

  const text = pickLocalizedText(texts, i18n.language ?? "en");
  if (!text) return null;

  return (
    <Alert variant="info">
      <InfoIcon />
      <AlertDescription dangerouslySetInnerHTML={{ __html: text }} />
    </Alert>
  );
}
